import { useEffect, useState } from 'react'

import { useAppDispatch } from 'common/hooks/redux'

import { resyncTeam } from 'features/TeamChat/api/teamChat.cache'

import { handleMessageSent, handleRequestChanged } from './teamEvents'
import { createTeamSocket, presenceChannelName, teamChannelName } from './teamSocket'
import { TEAM_EVENTS } from './teamSocket.constants'

type Args = { enabled: boolean; doctorId?: number; meId?: number }

// Live means the private channel is subscribed; anything else falls back to polling.
export const useTeamRealtime = ({ enabled, doctorId, meId }: Args): { isLive: boolean } => {
  const dispatch = useAppDispatch()
  const [isLive, setIsLive] = useState(false)

  useEffect(() => {
    if (!enabled || !doctorId || !meId) return
    const socket = createTeamSocket()
    if (!socket) return
    const teamName = teamChannelName(doctorId)
    const presenceName = presenceChannelName(doctorId)
    const team = socket.subscribe(teamName)
    // The backend reads "online" from this channel's members.
    socket.subscribe(presenceName)
    team.bind(TEAM_EVENTS.MESSAGE_SENT, (p: unknown) => dispatch(handleMessageSent(p, meId)))
    team.bind(TEAM_EVENTS.REQUEST_CHANGED, (p: unknown) => dispatch(handleRequestChanged(p, meId)))
    team.bind('pusher:subscription_succeeded', () => {
      setIsLive(true)
      dispatch(resyncTeam())
    })
    team.bind('pusher:subscription_error', () => setIsLive(false))
    socket.connection.bind('state_change', ({ current }: { current: string }) => {
      if (current !== 'connected') setIsLive(false)
    })
    return () => {
      team.unbind_all()
      socket.unsubscribe(teamName)
      socket.unsubscribe(presenceName)
      socket.disconnect()
      setIsLive(false)
    }
  }, [enabled, doctorId, meId, dispatch])

  return { isLive }
}
